import React from "react";
import { Link } from "react-router-dom";
import useLanguage from "../../hooks/useLanguage";
import translationsData from "../../data/translations.json";
import Button from "../common/Button";

const CTASection = () => {
  const { language } = useLanguage();

  const contactBtn =
    language === "ko"
      ? translationsData.buttons.contact
      : translationsData.buttons.contactEn;
  const ctaTitle =
    language === "ko"
      ? "첨단 레이다 센서 기술이 필요하신가요?"
      : "Need Advanced Radar Sensor Technology?";
  const ctaSubtitle =
    language === "ko"
      ? "지금 문의하시면 전문가가 최적의 솔루션을 제안해 드립니다"
      : "Contact us now and our experts will provide the optimal solution for you";

  return (
    <section className="py-16 md:py-24 bg-gradient-to-r from-blue-600 via-blue-700 to-blue-800 text-white">
      <div className="max-w-7xl mx-auto px-4 md:px-8 text-center">
        {/* CTA Title */}
        <h2 className="text-3xl md:text-4xl font-bold mb-4">{ctaTitle}</h2>

        {/* CTA Subtitle */}
        <p className="text-xl md:text-2xl text-blue-100 mb-8 max-w-3xl mx-auto">
          {ctaSubtitle}
        </p>

        {/* CTA Button */}
        <Link to="/contact">
          <Button
            variant="primary"
            size="lg"
            className="px-10 py-4 text-lg bg-white !text-blue-700 hover:bg-blue-50 !hover:text-white transform hover:scale-105 transition-all duration-300"
          >
            {contactBtn}
          </Button>
        </Link>
      </div>
    </section>
  );
};

export default CTASection;
